"use client";
import { useReducedMotion as e } from "motion/react";
import { useSyncExternalStore as t } from "react";
//#region src/motion/useMotionPolicy.ts
var n = !1, r = /* @__PURE__ */ new Set();
function i(e) {
	if (n !== e) {
		n = e;
		for (let e of r) e();
	}
}
var a = () => {
	i(!1);
}, o = (e) => {
	let t = e.target;
	i(!(t instanceof HTMLElement && (t.matches("input, textarea") || t.isContentEditable) && (e.key.length === 1 || e.key === "Backspace" || e.key === "Delete") && !e.ctrlKey && !e.metaKey && !e.altKey));
};
function s(e) {
	return r.size || (document.addEventListener("pointerdown", a, !0), document.addEventListener("keydown", o, !0)), r.add(e), () => {
		r.delete(e), r.size || (document.removeEventListener("pointerdown", a, !0), document.removeEventListener("keydown", o, !0));
	};
}
function c() {
	return {
		keyboard: t(s, () => l(), () => !1),
		reduced: !!e()
	};
}
var l = () => n;
//#endregion
export { c as useMotionPolicy };
